/*
  ag-completar.js — «Añade con un toque» (Claude, orden de Marco del 19/10/2026; ADR-014).

  Cuando la cesta no llega al mínimo de 10 €, el aviso que sale al añadir ofrece 3 productos baratos de lo mismo,
  cada uno con su botón. En la cesta (cajón y /cart) hace lo mismo mientras no llega a 10 € o a los 35 € del envío
  gratis. Un toque añade el formato más barato (100 g casi siempre).

  De dónde salen: primero la colección en la que se está, en su orden; luego las recomendaciones de Shopify del
  último producto añadido, solo del mismo tipo. Se descartan los que ya están en la cesta, los que no tienen un
  formato disponible entre 1 y 6 €, el café (pide molido) y la tarjeta regalo.

  Los contenedores los pinta el tema y el morph de Horizon no los toca (data-skip-node-update y
  data-skip-subtree-update): [data-ag-completar="aviso"] en snippets/cart-free-shipping-toast.liquid y
  [data-ag-completar="cesta"] (desde el 26/10, bajo la barra de envío: snippets/cart-free-shipping.liquid en el cajón
  y snippets/free-shipping-bar.liquid en /cart; antes estaba al final de snippets/cart-summary.liquid). Sin movimiento
  propio: el aviso entra y sale como siempre (pieza de Astra). Con agMedicion presente, registra «sugerido» y
  «completado».

  26/10/2026 (Claude): el mismo contenedor de la cesta ofrece además el REGALO DE HALLOWEEN (ver más abajo): del 27/10
  al 01/11 (hora de Madrid, window.agCampana de snippets/ag-campana.liquid), con 35 € o más y sin las pepitas dentro,
  un botón las añade. El descuento automático que las deja a 0 € lo crea la tienda en Shopify.
*/
(function () {
  'use strict';
  if (window.agCompletar) return;

  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MIN_PRECIO = 100, MAX_PRECIO = 600, CUANTOS = 3;
  var EXCLUIR = /caf[eé]|tarjeta|gift/i;
  var ICONO_MAS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
  var ICONO_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  function envio() { return window.agEnvio || null; }
  function minimo() { return (envio() && envio().MIN) || 1000; }
  function umbral() { return (envio() && envio().UMBRAL) || 3500; }
  function eur(c) {
    if (envio()) return envio().eur(c);
    return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formato(v) {
    if (!v || /default title/i.test(v)) return '';
    return String(v).replace(/(\d)\s*(kg|g|ml|cl|l)\b/gi, function (m, d, u) { return d + ' ' + u.toLowerCase(); });
  }
  function imagen(u) {
    if (u && typeof u === 'object') u = u.src || '';
    if (!u) return '';
    u = String(u);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  // ---- Datos ----
  var memo = {};
  function json(url) {
    if (!memo[url]) {
      memo[url] = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return memo[url];
  }
  function leerCesta() {
    return fetch(RAIZ + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function centimos(p) { return typeof p === 'number' ? p : Math.round(parseFloat(p) * 100); }

  // Un producto de cualquiera de las dos fuentes, con su formato disponible más barato.
  function normalizar(p) {
    if (!p) return null;
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return null;
    vs.sort(function (a, b) { return centimos(a.price) - centimos(b.price); });
    var v = vs[0];
    return {
      id: p.id,
      titulo: p.title || '',
      tipo: p.type || p.product_type || '',
      variante: v.id,
      formato: formato(v.title),
      precio: centimos(v.price),
      img: imagen(p.featured_image || (p.images && p.images[0]))
    };
  }

  function coleccionActual() {
    var m = location.pathname.match(/\/collections\/([^/?#]+)/);
    return m && m[1] !== 'all' ? m[1] : null;
  }

  var ultimoAnadido = null;
  function ancla(cesta) {
    var items = (cesta && cesta.items) || [];
    var it = null;
    for (var i = 0; i < items.length && ultimoAnadido; i++) if (items[i].product_id === ultimoAnadido) { it = items[i]; break; }
    it = it || items[0];
    return it ? { id: it.product_id, tipo: it.product_type || '' } : null;
  }

  function candidatos(a) {
    var col = coleccionActual();
    return Promise.all([
      col ? json(RAIZ + 'collections/' + col + '/products.json?limit=30') : Promise.resolve(null),
      a ? json(RAIZ + 'recommendations/products.json?product_id=' + a.id + '&limit=10&intent=related') : Promise.resolve(null)
    ]).then(function (r) {
      var deColeccion = ((r[0] && r[0].products) || []).map(normalizar);
      var relacionados = ((r[1] && r[1].products) || []).map(normalizar).filter(function (p) {
        return p && (!a.tipo || p.tipo === a.tipo);
      });
      return deColeccion.concat(relacionados);
    });
  }

  function elegir(lista, cesta, falta) {
    var enCesta = {}, vistos = {}, sal = [];
    ((cesta && cesta.items) || []).forEach(function (it) { enCesta[it.product_id] = 1; });
    lista.forEach(function (p) {
      if (!p || vistos[p.id] || enCesta[p.id]) return;
      vistos[p.id] = 1;
      if (p.precio < MIN_PRECIO || p.precio > MAX_PRECIO) return;
      if (EXCLUIR.test(p.tipo) || EXCLUIR.test(p.titulo)) return;
      sal.push(p);
    });
    // Si uno solo cierra lo que falta, va primero.
    if (falta > 0 && falta <= MAX_PRECIO) {
      for (var i = 0; i < sal.length; i++) {
        if (sal[i].precio >= falta) { if (i > 0) sal.unshift(sal.splice(i, 1)[0]); break; }
      }
    }
    return sal.slice(0, CUANTOS);
  }

  // ---- Pintar ----
  function ocultar(c) { if (c && !c.hidden) c.hidden = true; }
  // nota: HTML ya escapado que va ANTES de las sugerencias (aviso del regalo de Halloween). Sin sugerencias pero con
  // nota, pinta solo la nota y devuelve false (no cuenta como «sugerido»).
  function pintar(cont, lista, nota) {
    if (!cont) return false;
    if (!lista.length && !nota) { ocultar(cont); return false; }
    var firma = lista.map(function (p) { return p.variante; }).join(',') + (nota ? '|' + nota : '');
    if (cont.classList.contains('ag-completar--regalo')) {
      // venía de pintar el regalo: se vuelve a las sugerencias
      cont.classList.remove('ag-completar--regalo');
      cont.setAttribute('aria-label', 'Añade con un toque');
      cont.removeAttribute('data-firma');
    }
    if (cont.getAttribute('data-firma') !== firma) {
      var html = nota ? '<p class="ag-regalo__aviso">' + nota + '</p>' : '';
      if (lista.length) html += '<p class="ag-completar__cab">Añade con un toque</p><ul class="ag-completar__lista" role="list">';
      lista.forEach(function (p) {
        var etiqueta = 'Añadir ' + (p.formato ? p.formato + ' de ' : '') + p.titulo + ', ' + eur(p.precio);
        html += '<li><button type="button" class="ag-completar__item" data-variante="' + esc(p.variante) + '" aria-label="' + esc(etiqueta) + '">' +
          (p.img
            ? '<img class="ag-completar__img" src="' + esc(p.img) + '" alt="" width="44" height="44" loading="lazy" decoding="async">'
            : '<span class="ag-completar__img" aria-hidden="true"></span>') +
          '<span class="ag-completar__mas" aria-hidden="true">' + ICONO_MAS + '</span>' +
          '<span class="ag-completar__nombre">' + esc(p.titulo) + '</span>' +
          // Precio primero y entero; el formato al lado o debajo si no cabe (tarjetas de 84 px en /cart en móvil).
          '<span class="ag-completar__precio"><strong>' + esc(eur(p.precio)) + '</strong>' +
          (p.formato ? '<span class="ag-completar__formato">' + esc(p.formato) + '</span>' : '') + '</span>' +
          '</button></li>';
      });
      cont.innerHTML = html + (lista.length ? '</ul>' : '');
      cont.setAttribute('data-firma', firma);
    }
    cont.hidden = false;
    return lista.length > 0;
  }

  function medir(tipo, lugar) {
    try { if (window.agMedicion && window.agMedicion.registrar) window.agMedicion.registrar(tipo, lugar); } catch (e) {}
  }

  // ---- Regalo de Halloween (26/10/2026) ----
  // Del 27/10 al 01/11 (hora de Madrid): con 35 € o más en la cesta y sin las pepitas dentro, un toque las añade.
  // El importe que cuenta es el de la cesta SIN la línea del regalo y tras descuentos (cart.total_price), el mismo
  // que ya usan la barra y el envío gratis. Si el regalo está dentro pero se paga (la cesta bajó de 35 €), avisa de
  // cuánto falta. El descuento automático que lo deja a 0 € NO vive en el tema: lo crea la tienda en Shopify.
  // Sin medición: el Worker agranel-medicion solo admite «sugerido» y «completado» de «Añade con un toque» y el regalo
  // los mezclaría.
  var REGALO = {
    campana: 'halloween',
    variante: 54039636279623,                       // 100 g de Pepitas de Chocolate
    handle: 'pepitas-de-chocolate-a-granel-en-madrid',
    desde: 3500
  };
  function regaloActivo() {
    try { return !!(window.agCampana && window.agCampana.activa() === REGALO.campana); } catch (e) { return false; }
  }
  function lineaRegalo(c) {
    var items = (c && c.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].variant_id === REGALO.variante) return items[i];
    return null;
  }
  function baseRegalo(c) {
    var l = lineaRegalo(c);
    return c.total_price - (l ? (l.final_line_price || 0) : 0);
  }
  // 'oferta' (botón para añadir), 'falta' (está dentro pero la cesta ya no llega: aviso) o null
  function regaloModo(c) {
    if (!c || !c.item_count || !regaloActivo()) return null;
    var l = lineaRegalo(c), base = baseRegalo(c);
    if (!l && base >= REGALO.desde) return 'oferta';
    if (l && l.final_line_price > 0 && base < REGALO.desde) return 'falta';
    return null;
  }
  var regaloDatos = null;
  function datosRegalo() {
    if (!regaloDatos) {
      regaloDatos = json(RAIZ + 'products/' + REGALO.handle + '.js').then(function (p) {
        if (!p || !p.variants) return null;
        var v = null;
        p.variants.forEach(function (x) { if (x.id === REGALO.variante) v = x; });
        if (!v || !v.available) return null;
        return { titulo: p.title || 'Pepitas de Chocolate', img: imagen(p.featured_image || (p.images && p.images[0])) };
      });
    }
    return regaloDatos;
  }
  // Aviso (HTML escapado) de que el regalo ya está dentro pero la cesta no llega a 35 €: se pinta antes de las sugerencias.
  function notaRegalo(falta) {
    return '<strong>Las pepitas de chocolate de regalo son gratis desde 35 €.</strong> Te faltan <strong>' + esc(eur(falta)) + '</strong> para que lo sean.';
  }
  function pintarRegalo(cont, d) {
    if (!cont) return;
    var firma = 'regalo:oferta';
    if (cont.getAttribute('data-firma') !== firma) {
      var html = '<div class="ag-regalo">' +
        (d && d.img
          ? '<img class="ag-regalo__img" src="' + esc(d.img) + '" alt="" width="52" height="52" loading="lazy" decoding="async">'
          : '<span class="ag-regalo__img" aria-hidden="true"></span>') +
        '<div class="ag-regalo__cuerpo">' +
        '<p class="ag-regalo__tit">Tu regalo de Halloween</p>' +
        '<p class="ag-regalo__txt">100 g de pepitas de chocolate, gratis en pedidos desde 35 €</p>' +
        '<p class="ag-regalo__nota">Contienen soja. No para menores de 5 años.</p>' +
        '</div>' +
        '<button type="button" class="ag-regalo__btn" data-variante="' + esc(REGALO.variante) + '" aria-label="Añadir gratis 100 g de pepitas de chocolate">Añadir</button>' +
        '</div>';
      cont.innerHTML = html;
      cont.setAttribute('data-firma', firma);
    }
    cont.classList.add('ag-completar--regalo');
    cont.setAttribute('aria-label', 'Regalo de Halloween');
    cont.hidden = false;
  }

  // ---- El aviso que sale al añadir: solo bajo el mínimo ----
  var toast = document.getElementById('fstoast');
  var enAviso = document.querySelector('[data-ag-completar="aviso"]');
  function toastAbierto() {
    if (!toast) return false;
    try { if (toast.matches(':popover-open')) return true; } catch (e) {}
    return toast.classList.contains('is-visible');
  }
  // En la ficha de móvil el aviso va arriba, sobre la foto: allí se queda pequeño.
  function fichaMovil() { return !!document.querySelector('.agp') && window.innerWidth <= 749; }

  var pendienteAviso = 0;
  function actualizarAviso() {
    if (!enAviso) return;
    if (!toastAbierto() || !toast.classList.contains('fstoast--minimo') || fichaMovil()) { ocultar(enAviso); return; }
    var turno = ++pendienteAviso;
    leerCesta().then(function (c) {
      if (turno !== pendienteAviso) return;
      if (!c || !c.item_count || c.total_price >= minimo()) { ocultar(enAviso); return; }
      return candidatos(ancla(c)).then(function (l) {
        if (turno !== pendienteAviso || !toastAbierto()) return;
        if (pintar(enAviso, elegir(l, c, minimo() - c.total_price))) {
          toast.dispatchEvent(new CustomEvent('ag:completar'));
          medir('sugerido', 'aviso');
        }
      });
    });
  }
  if (toast && enAviso) {
    toast.addEventListener('toggle', function (e) { if (e.newState === 'open') actualizarAviso(); else ocultar(enAviso); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (toastAbierto()) actualizarAviso(); })
        .observe(toast, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ---- La cesta (cajón y /cart): bajo 10 € o bajo 35 € ----
  var pendienteCesta = 0;
  function visible(el) { return !!(el && el.offsetParent !== null); }
  function actualizarCestas(medirAhora) {
    var conts = document.querySelectorAll('[data-ag-completar="cesta"]');
    if (!conts.length) return;
    var turno = ++pendienteCesta;
    leerCesta().then(function (c) {
      if (turno !== pendienteCesta) return;
      var modo = regaloModo(c);
      if (modo === 'oferta') {
        return datosRegalo().then(function (d) {
          if (turno !== pendienteCesta) return;
          var cs = document.querySelectorAll('[data-ag-completar="cesta"]');
          if (!d) { [].forEach.call(cs, ocultar); return; } // pepitas agotadas: no se ofrece
          [].forEach.call(cs, function (cont) { pintarRegalo(cont, d); });
        });
      }
      // «falta»: el regalo está dentro pero la cesta ya no llega a 35 €; el aviso va antes de las sugerencias de siempre.
      var nota = modo === 'falta' ? notaRegalo(REGALO.desde - baseRegalo(c)) : '';
      var est = c && envio() ? envio().estado(c.total_price, c.item_count) : null;
      if (est !== 'minimo' && est !== 'envio') {
        [].forEach.call(document.querySelectorAll('[data-ag-completar="cesta"]'), function (cont) { pintar(cont, [], nota); });
        return;
      }
      var meta = est === 'minimo' ? minimo() : umbral();
      return candidatos(ancla(c)).then(function (l) {
        if (turno !== pendienteCesta) return;
        var lista = elegir(l, c, meta - c.total_price);
        [].forEach.call(document.querySelectorAll('[data-ag-completar="cesta"]'), function (cont) {
          if (pintar(cont, lista, nota) && medirAhora && visible(cont)) {
            medir('sugerido', cont.closest('cart-drawer-component') ? 'cajon' : 'pagina');
          }
        });
      });
    });
  }

  // ---- Añadir con un toque ----
  function anadir(variante, lugar) {
    var secciones = [].map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (e) {
      return e.getAttribute('data-section-id');
    }).filter(Boolean);
    var cuerpo = { items: [{ id: Number(variante), quantity: 1 }] };
    if (secciones.length) cuerpo.sections = secciones.join(',');
    return fetch(RAIZ + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        return leerCesta().then(function (c) {
          var linea = res.items && res.items[0] ? res.items[0] : res;
          ultimoAnadido = linea && linea.product_id ? linea.product_id : ultimoAnadido;
          // Desde el aviso no se abre el cajón (igual que la compra rápida de las tarjetas).
          var cajon = document.querySelector('cart-drawer-component');
          var auto = lugar === 'aviso' && cajon && cajon.hasAttribute('auto-open');
          if (auto) cajon.removeAttribute('auto-open');
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: linea,
              sourceId: 'ag-completar',
              data: { source: 'ag-core', itemCount: c ? c.item_count : undefined, cart: c || undefined, sections: res.sections }
            }
          }));
          if (auto) setTimeout(function () { cajon.setAttribute('auto-open', ''); }, 80);
          return c;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.ag-completar__item');
    if (!b || b.disabled) return;
    e.preventDefault();
    var cont = b.closest('[data-ag-completar]');
    var lugar = cont && cont.getAttribute('data-ag-completar') === 'aviso' ? 'aviso' : (b.closest('cart-drawer-component') ? 'cajon' : 'pagina');
    b.disabled = true;
    b.classList.add('is-cargando');
    anadir(b.getAttribute('data-variante'), lugar).then(function () {
      b.classList.remove('is-cargando');
      b.classList.add('is-hecho');
      var mas = b.querySelector('.ag-completar__mas');
      if (mas) mas.innerHTML = ICONO_OK;
      medir('completado', lugar);
    }).catch(function () {
      b.classList.remove('is-cargando');
      b.classList.add('is-error');
      var precio = b.querySelector('.ag-completar__precio');
      if (precio) precio.textContent = 'No disponible';
    });
  });

  // Botón del regalo de Halloween: el mismo añadido que las sugerencias, sin medición propia.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.ag-regalo__btn');
    if (!b || b.disabled) return;
    e.preventDefault();
    var lugar = b.closest('cart-drawer-component') ? 'cajon' : 'pagina';
    b.disabled = true;
    b.classList.add('is-cargando');
    anadir(b.getAttribute('data-variante'), lugar).then(function () {
      b.classList.remove('is-cargando');
      b.classList.add('is-hecho');
      b.textContent = 'Añadido';
    }).catch(function () {
      b.classList.remove('is-cargando');
      b.classList.add('is-error');
      b.textContent = 'No disponible';
    });
  });

  // ---- Cuándo se recalcula ----
  var esperaCesta = 0;
  document.addEventListener('cart:update', function (ev) {
    var d = (ev && ev.detail) || {};
    var r = d.resource;
    if (r && r.product_id) ultimoAnadido = r.product_id;
    // Tras un toque propio se deja ver la marca de «hecho» un momento antes de cambiar la lista.
    var pausa = d.sourceId === 'ag-completar' ? 900 : 250;
    setTimeout(actualizarAviso, pausa + 150);
    clearTimeout(esperaCesta);
    esperaCesta = setTimeout(function () { actualizarCestas(false); setTimeout(function () { actualizarCestas(false); }, 900); }, pausa);
  });
  if ('MutationObserver' in window) {
    // Al abrir el cajón: se recalcula y, si se ve, cuenta como sugerido.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var el = muts[i].target;
        if (el.tagName === 'DIALOG' && el.open && el.closest && el.closest('cart-drawer-component')) { actualizarCestas(true); return; }
      }
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
  actualizarCestas(/\/cart\/?$/.test(location.pathname));

  window.agCompletar = { version: 2, actualizar: function () { actualizarAviso(); actualizarCestas(false); } };
})();
